/* eslint-disable react/prop-types */

import React from 'react'

import { IoSearch } from "react-icons/io5";
import format from "date-fns/format";

import { Collapse } from "components/Collapse";
import Button from "components/Button";
import { FormSearchHotels } from "components/FormSearchHotels";
import { Informations } from './styles'

import { useApp } from "contexts/AppContext";

export function SearchBarHotels({info, handleInfo, searchHotels}) {

    const { hotelState } = useApp()
    const { locationSearchHotel, datesSearchHotel, guestsSearchHotel } = hotelState
    const { adults, children } = guestsSearchHotel
    const totalGuests = adults + children

    return (
        <div className="container-search-bar pt-custom border-bottom bg-white">
            { info && (
                <>
                    <Informations>
                        <p>{ locationSearchHotel.id ?? '-' } <span>Destino</span></p>
                        <p>{ datesSearchHotel.startDate ? format(datesSearchHotel.startDate, "dd/MM/yy") : '-' }<span>Check-in</span></p>
                        <p>{ datesSearchHotel.endDate ? format(datesSearchHotel.endDate, "dd/MM/yy") : '-' }<span>Check-out</span></p>
                        <p>{ totalGuests }<span>Hóspedes</span></p>
                    </Informations>
                    <div className="d-flex justify-content-center mb-3">
                        <Button width="200px" onClick={handleInfo} data-bs-toggle="collapse"
                                data-bs-target="#filter-collapse" aria-expanded="false" aria-controls="filter-collapse">
                            <IoSearch className="me-2"/> REFAZER BUSCA
                        </Button>
                    </div>
                </>
            )}
            <Collapse handleClick={handleInfo}>
                <p className="fw-bolder pt-3">Busca de Hotéis</p>

                <FormSearchHotels />

                <div className="d-flex justify-content-center mb-3">
                    <Button onClick={() => searchHotels(true)} width="200px">
                        <IoSearch className="me-2"/>REFAZER BUSCA
                    </Button>
                </div>
            </Collapse>
        </div>
    )
}
